// @flow

import * as React from 'react';
import { Icon } from '@ta/styleguide.icon';
import { localize, globalize } from '@ta/common.i18n';
import styles from './SavingsCallout.less';

/** The component props for a <SavingsCallout> */
export type Props = {
  /** The savings amount. Will be formatted as a currency integer. */
  savings: number,

  /** The price. Will be formatted as currency integer. */
  price: number,
};

/**
 * A price display with a savings callout. The price and savings amount will be formatted as currency integers.
 */
const SavingsCallout = ({ price, savings }: Props) => (
  <div className={`ui_level is-mobile ${styles.container}`}>
    <div className={`level-left ${styles.save}`}>
      <Icon name="star" className={styles.icon} />
      {localize('hotels_save_money', {
        '0': globalize.formatCurrencyInteger(savings),
      })}
    </div>
    <div className={`level-right ${styles.off}`}>{globalize.formatCurrencyInteger(price)}</div>
  </div>
);

export default SavingsCallout;
